<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent:00em; padding-bottom:15px;">I would like to thank Robin, for unflagging encouragement and long hours of bringing a hand-written text to the digital age, and for ribbing me for decades. To my eclectic and diverse editorial critics, Debbie, Jim, Robin, Terry, who all said they would buy it, holding you to it.</p>
<p style="text-indent:00em;">To Doc. G. Alan Coler, for advice and encouragement.</p>
<p style="text-indent:00em; ">To Austin Macauley Publishers, for taking a shot.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?cc582d4a